import { isUndefined } from 'lodash';
import React from 'react';

export interface TRPProps {
  registeredTradeMark?: boolean;
}

const TRP: React.VFC<TRPProps> = ({ registeredTradeMark }) => (
  <span className="text-nowrap">
    {!isUndefined(registeredTradeMark) ? 'T. Rowe Price®' : 'T. Rowe Price'}
  </span>
);

export default TRP;
